import React, { useEffect, useRef, useState, useCallback } from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useParams } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { Card, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import RenderLabelOption from '../RenderLabelOption';
import ImgDropzone from '../../../../../Components/ImgDropzone/ImgDropzone';
import StatusConfigComponent from './StatusConfig';
import NumberPerConfigComponent from './NumberPerConfig';
import CalculationConfigComponent from './CalculationConfig';
import SignatureConfigComponent from './SignatureConfig';
import CompanyStampConfigComponent from './CompanyStampConfig';
import ImageConfigComponent from './ImageConfig';
import DividerConfigComponent from './DividerConfig';
import ContainerColumnConfigComponent from './ContainerColumnConfig';
import AlignmentConfigComponent from './AlignmentConfig';
import BoldConfig from './BoldConfig';
import BorderConfig from './BorderConfig';
import BorderColorConfig from './BorderColorConfig';
import BorderStyleConfig from './BorderStyleConfig';
import BackgraundColorConfig from './BackgraundColorConfig';
import ColorConfig from './ColorConfig';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import { customStyles, imageUrl } from '../../../../../Components/helper';
import * as customModuleAction from '../../Store/CustomModule.action';
import { useCustomModuleState } from '../../Context/index';

function ConfigModal({ toggle, data, dataIndex, submit, setCustomModuleState }) {
  const { t } = useTranslation('common');
  const { moduleLibId } = useParams();
  const [array, setArray] = useState([]);
  const [obj, setObj] = useState(null);
  const [colourSwitch, setColourSwitch] = useState(false);
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    controlKey: '',
  });
  const { customModuleState } = useCustomModuleState();
  const varCompanyStamp = 'Company Stamp';
  const childRef = useRef();
  const uniqueKey = uuidv4();
  const dispatch = useDispatch();
  const alignmentControls = [
    'Text_Area',
    'Text',
    'Number_Decimal',
    'Number_Percentage',
    'Date_Picker',
    'Status',
    'Signature',
    'Label',
    'Time_Picker',
    'Heading',
    'Divider',
    'Source',
    'Calculation',
    'Dependent',
  ];
  const boldControls = [
    'Text_Area',
    'Text',
    'Number_Decimal',
    'Number_Percentage',
    'Dropdown',
    'Multi_Dropdown',
    'Date_Picker',
    'Status',
    'Signature',
    'Label',
    'Time_Picker',
    'Heading',
    'Source',
    'Calculation',
  ];
  const borderControls = [
    'Text_Area',
    'Text',
    'Signature',
    'Date_Picker',
    'Time_Picker',
    'Number_Decimal',
    'Number_Percentage',
    'HTMLControl',
    'Source',
    'Calculation',
  ];
  const BackgroundControls = ['Text_Area', 'Text', 'Heading', 'Source', 'Calculation', 'Colorfill'];
  const ColorControls = [
    'Text_Area',
    'Text',
    'Number_Decimal',
    'Number_Percentage',
    'Date_Picker',
    'Time_Picker',
    'Heading',
    'Divider',
    'Source',
    'Calculation',
  ];
  const subHeadingOptions = [
    { label: 'Normal Text', value: 'normal' },
    { label: 'H1', value: 'h1' },
    { label: 'H2', value: 'h2' },
    { label: 'H3', value: 'h3' },
  ];
  const fontSizeOptions = [
    { label: '12 px', value: '12' },
    { label: '14 px', value: '14' },
    { label: '16 px', value: '16' },
    { label: '18 px', value: '18' },
  ];
  const fontSizeTextControl = [
    { label: '11 px', value: '11' },
    { label: '13 px', value: '13' },
    { label: '15 px', value: '15' },
    { label: '17 px', value: '17' },
  ];
  const dividerStyleOptions = [
    { label: 'Solid', value: 'solid' },
    { label: 'Dashed', value: 'dashed ' },
  ];
  const requiredLabelKeys = ['Dropdown', 'Multi_Dropdown', 'Label'];
  useEffect(() => {
    if (data?.forLabel) {
      setObj({ ...data });
    } else if (!isEmpty(data?.columns)) {
      setArray([...(data?.columns || []).flatMap((e) => e)]);
    } else {
      setObj({ ...data });
    }
    setColourSwitch(data?.isColourCoding);
  }, [data]);

  const changetarget = (e, i, type) => {
    const updatedArray = [...array];
    updatedArray[i][type] = e.target.checked;
    setArray([...updatedArray]);
  };

  const onChange = (e, name, i) => {
    const object = cloneDeep(obj);
    if (!object.colourArray) {
      object.colourArray = [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ];
    }

    switch (name) {
      case 'Label':
        object.label = e;
        break;
      case 'Placeholder':
        object.placeholder = e;
        break;
      case 'Supplier Visible':
        object.supplierVisible = e;
        break;
      case 'range':
        object.range = e;
        object.value = null;
        break;
      case 'Supplier Editable':
        object.supplierEditable = e;
        break;
      case 'colourHexCode':
        object.statusColours[i].colourHexCode = e;
        break;
      case 'colourName':
        object.statusColours[i].colourName = e;
        break;
      case 'colourValue':
        object.colourArray[i].colourValue = e?._id;
        break;
      case 'startPercentage':
      case 'endPercentage':
        object.colourArray[i][name] = e;
        break;

      case 'setDefault':
        object.statusColours.forEach((color, index) => {
          object.statusColours[index] = { ...color, setDefault: false };
        });
        object.statusColours[i].setDefault = e;
        break;

      default:
        object.options[i].name = e;
        object.options[i].label = e;
        if (object?.key === 'Multi_Dropdown') {
          object.options[i].value = e;
        }
        break;
    }
    setObj({ ...object });
  };

  const handleFont = (e, i) => {
    const object = cloneDeep(obj);
    object.fontFamily = e;
    object.fontStyles.map((fontObj) => ({
      ...fontObj,
      isActive: false,
    }));
    object.fontStyles[i].isActive = true;
    setObj({ ...object });
  };
  const handleHeadingStyle = (style) => {
    const object = cloneDeep(obj);
    object.headingStyle = style;
    setObj({ ...object });
  };
  const handleFontSize = (style) => {
    const object = cloneDeep(obj);
    object.fontSize = style;
    setObj({ ...object });
  };
  const handleDividerStyle = (style) => {
    const object = cloneDeep(obj);
    object.dividerStyle = style;
    setObj({ ...object });
  };
  const addOption = (addType) => {
    const optionLength = addType?.options?.length;
    const object = cloneDeep(obj);
    object.label = obj.label;
    object.placeholder = obj.placeholder;

    if (addType.key === 'Multi_Dropdown') {
      object.options?.push({ label: '', value: '' });
    } else if (addType.key === 'Ratio_Button') {
      object.options?.push({ name: '', uniqueKey: `${uniqueKey}_radio_${optionLength + 1}` });
    } else if (addType.key === 'Check_Boxes') {
      object.options?.push({ name: '', uniqueKey: `${uniqueKey}_check_${optionLength + 1}` });
    } else {
      object.options?.push({ name: '', uniqueKey: `${uniqueKey}_options_${optionLength + 1}` });
    }
    setObj({ ...object });
  };

  const removeOption = (opi) => {
    const object = cloneDeep(obj);
    object.label = obj.label;
    object.placeholder = obj.placeholder;
    object.options?.splice(opi, 1);
    setObj({ ...object });
  };

  const chcekingFromDynamicArray = (colourArray, value) => {
    return typeof value === 'object' ? colourArray?.find((ele) => ele?._id === value?._id) : colourArray?.find((ele) => ele?._id === value);
  };

  const forSwitch = (e) => {
    setColourSwitch(e?.target?.checked);
    const object = { ...obj };
    object.isColourCoding = e?.target?.checked;
    setObj({ ...object });
  };

  const handleUploadImage = (key) => {
    setImageModal((prevState) => ({
      ...prevState,
      isOpen: true,
      controlKey: key,
    }));
  };

  const handleRemoveImage = (key) => {
    const object = { ...obj };
    if (key === 'Signature') {
      object.digitalSignPath = '';
    } else if (key === 'Image') {
      object.imageUrl = '';
    } else if (key === varCompanyStamp) {
      object.companyLogo = '';
    }
    setObj({ ...object });
  };

  const swapArrayLocs = (arr, index1, index2) => {
    // Create a new array instead of modifying the parameter directly
    const newArr = [...arr];

    // Swap elements in the new array
    const temp = newArr[index1];
    newArr[index1] = newArr[index2];
    newArr[index2] = temp;

    return newArr;
  };

  const moveLabel = (dragIndex, hoverIndex) => {
    const object = { ...obj };
    const currList = swapArrayLocs(object.labelColours, dragIndex, hoverIndex);
    object.labelColours = currList;
    setObj({ ...object });
  };

  const removelabel = (index) => {
    const object = { ...obj };
    object.labelColours.splice(index, 1);
    setObj({ ...object });
  };
  const handleLabelChange = (value, index, key) => {
    const object = { ...obj };
    object.labelColours[index][key] = value;
    setObj({ ...object });
  };

  const renderlabelList = useCallback(
    (label, labelIndex) => {
      return (
        <RenderLabelOption // label Item changes
          column={label}
          index={labelIndex}
          moveCard={moveLabel}
          id={`${label?.Nmae}_${labelIndex}`}
          removeLabel={removelabel}
          handleChange={handleLabelChange}
          wholeArry={obj?.labelColours}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [obj?.labelColours],
  );
  const getImage = (imagePath) => {
    let logo = null;
    if (imagePath?.includes('base64')) {
      logo = imagePath;
    } else {
      logo = `${imageUrl}/${imagePath}`;
    }
    return logo;
  };
  const hasAccessAlignment = (keyName) => {
    return alignmentControls.includes(keyName);
  };
  const hasAccessBold = (keyName) => {
    return boldControls.includes(keyName);
  };
  const hasAccessBorder = (keyName) => {
    return borderControls.includes(keyName);
  };
  const hasAccessBackground = (keyName) => {
    return BackgroundControls.includes(keyName);
  };
  const hasAccessColor = (keyName) => {
    return ColorControls.includes(keyName);
  };

  const handleOtherConfig = (e) => {
    const object = cloneDeep(obj);

    const propertyName = e.target.name;
    const isCheckbox = e.target.type === 'checkbox';
    const propertyValue = isCheckbox ? e.target.checked : e.target.value;

    const addedObj = { [propertyName]: propertyValue };

    object.otherConfiguration = { ...(object?.otherConfiguration || {}), ...addedObj };
    setObj({ ...object });
  };

  const handleBorderStyle = (val, key) => {
    const object = cloneDeep(obj);
    const addedObj = { [key]: val?.value };
    object.otherConfiguration = { ...(object?.otherConfiguration || {}), ...addedObj };

    setObj({ ...object });
  };
  const handleDividerSetting = (val, key) => {
    const object = cloneDeep(obj);
    const addedObj = { [key]: val };
    object.dividerProperty = { ...(object?.dividerProperty || {}), ...addedObj };
    setObj({ ...object });
  };

  const handleBoldLabel = (e) => {
    const object = cloneDeep(obj);
    object.boldLabel = e.target.checked;
    setObj({ ...object });
  };

  const openModals = () => {
    setCustomModuleState((prevState) => ({
      ...prevState,
      modalEdit: true,
      editPopup: false,
      disableDrag: true,
    }));
  };

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();
      const { imageRes } = croppedFileUrl;
      if (imageRes?.length && moduleLibId) {
        const s3Obj = {
          document: imageRes,
          documentName: `${moduleLibId}_${customModuleState?.editPopupPageId}_${customModuleState?.editPopupGridIndex}`,
        };
        const res = await dispatch(customModuleAction.uploadCMImage(s3Obj));
        const object = { ...obj };

        if (imageModal.controlKey === 'Signature') {
          object.digitalSignPath = `${res?.data}?t=${new Date().getTime()}`;
        } else if (imageModal.controlKey === 'Image') {
          object.imageUrl = `${res?.data}?t=${new Date().getTime()}`;
        } else {
          object.companyLogo = `${res?.data}?t=${new Date().getTime()}`;
        }

        setObj({ ...object });
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
        }));
      } else {
        toasterMsg(t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.MODULE_ID_REQUIRED'), 'danger');
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
        }));
      }
    } else {
      setImageModal((prevState) => ({
        ...prevState,
        isOpen: false,
      }));
    }
  };
  const trimLabel = (value, key, i) => {
    onChange(value.trim(), key, i);
  };

  const handleDependent = (e) => {
    return e === 'Source' ? t('CUSTOM_LIBRARY.SOURCE_TYPE.EDIT_SOURCE') : t('CUSTOM_LIBRARY.DEPENDENT_SETTING.EDIT_DEPENDENT');
  };

  const mainBodyData = () => {
    return data?.type === 'container' ? (
      <ContainerColumnConfigComponent data={data} array={array} changetarget={changetarget} />
    ) : (
      <>
        <strong className="p-2 d-block text-bold">{`${obj?.key} Properties`}</strong>
        <div className="label-container px-2 mt-1">
          <div className="input-group form-floating-label fixed-label">
            <input
              id="configLabel"
              type="text"
              className="form-control"
              name={obj?.name || 'Text Box'}
              placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.ENTER_TEXT')}
              value={obj?.label}
              onChange={(e) => onChange(e.target.value, 'Label')}
              onBlur={(e) => trimLabel(e.target.value, 'Label')}
            />
            <label htmlFor="configLabel" className="asterisk-req">
              {t('CUSTOM_MODULE.LABEL')} {requiredLabelKeys.includes(obj?.key) && <span className="p-0">*</span>}
            </label>
          </div>
          <div className="bold-check-control">
            <input type="checkbox" id="boldLabel" onChange={handleBoldLabel} checked={obj?.boldLabel} name="boldLabel" />
            <label htmlFor="boldLabel" title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.BOLD')}>
              <span className="icon-bold_new" />
            </label>
          </div>
        </div>
        <div className="px-2 mt-1">
          {['Source', 'Calculation', 'Dependent'].includes(data?.key) ? null : (
            <div className="input-group form-floating-label fixed-label">
              <input
                id="configPlaceholder"
                type="text"
                className="form-control"
                name={obj?.name || 'Text Box'}
                placeholder={`${t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.PLACEHOLDER')} ${obj?.label}`}
                value={obj?.placeholder}
                onChange={(e) => onChange(e.target.value, 'Placeholder')}
                onBlur={(e) => trimLabel(e.target.value, 'Placeholder')}
                maxLength="40"
              />
              <label htmlFor="configPlaceholder" className="asterisk-req">
                {t('CUSTOM_MODULE.PLACEHOLDER')}
              </label>
              <div className="text-count">{obj?.placeholder?.length || 0}/40</div>
            </div>
          )}
          {['Source', 'Calculation', 'Dependent'].includes(data?.key) && (
            <button className="btn btn-default bg-white mt-2" type="button" onClick={openModals}>
              {data?.key === 'Calculation' ? t('CUSTOM_LIBRARY.CALCULATION_TYPE.EDIT_CALCULATION') : handleDependent(data?.key)}
            </button>
          )}
          {data?.key === 'Heading' && (
            <>
              <p className="mt-2 mb-1 f-13">{t('CUSTOM_MODULE.SUB_HEADING')}</p>
              <Select
                name="Supplier"
                type="text"
                placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.SELECT_HEADING_TYPE')}
                options={subHeadingOptions}
                styles={customStyles}
                getOptionLabel={({ label }) => `${label}`}
                getOptionValue={({ value }) => `${value}`}
                value={obj?.headingStyle}
                onChange={(selected) => handleHeadingStyle(selected)}
              />
            </>
          )}
          {data?.key === 'Date_Picker' && (
            <>
              <p className="mt-2 mb-1 f-13">{t('CUSTOM_MODULE.FONT_SIZE')}</p>
              <Select
                name="Supplier"
                type="text"
                placeholder={t('CUSTOM_MODULE.FONT_SIZE')}
                options={fontSizeOptions}
                styles={customStyles}
                getOptionLabel={({ label }) => `${label}`}
                getOptionValue={({ value }) => `${value}`}
                value={obj?.fontSize}
                onChange={(selected) => handleFontSize(selected)}
              />
            </>
          )}

          {data?.key === 'Divider' && (
            <>
              <p className="mt-2 mb-1 f-13">{t('CUSTOM_MODULE.DIVIDER_STYLE')}</p>
              <Select
                name="Supplier"
                type="text"
                placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.SELECT_DIVIDER_STYLE')}
                options={dividerStyleOptions}
                styles={customStyles}
                className="common-select"
                classNamePrefix="common-select"
                getOptionLabel={({ label }) => `${label}`}
                getOptionValue={({ value }) => `${value}`}
                value={obj?.dividerStyle}
                onChange={(selected) => handleDividerStyle(selected)}
              />
            </>
          )}
        </div>
        <div className="d-flex">
          {hasAccessAlignment(data?.key) && <AlignmentConfigComponent obj={obj} handleAlignment={handleOtherConfig} />}
          {hasAccessBackground(data?.key) && <BackgraundColorConfig obj={obj} handleBackground={handleOtherConfig} />}
          {hasAccessColor(data?.key) && <ColorConfig obj={obj} handleColor={handleOtherConfig} />}
        </div>

        {hasAccessBold(data?.key) && <BoldConfig obj={obj} handleBold={handleOtherConfig} />}
        {hasAccessBorder(data?.key) && (
          <>
            <BorderConfig obj={obj} handleBorder={handleOtherConfig} />
            <BorderColorConfig obj={obj} handleBorder={handleOtherConfig} />
            <BorderStyleConfig obj={obj} handleBorderStyle={handleBorderStyle} />
          </>
        )}
        {(data?.key === 'Text' || data?.key === 'Text_Area') && (
          <div className="p-2 w-200px">
            <p className="mt-2 mb-1 f-13">{t('CUSTOM_MODULE.FONT_SIZE')}</p>
            <Select
              name="Supplier"
              type="text"
              placeholder={t('CUSTOM_MODULE.FONT_SIZE')}
              options={fontSizeTextControl}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              menuPosition="fixed"
              getOptionLabel={({ label }) => `${label}`}
              getOptionValue={({ value }) => `${value}`}
              value={obj?.fontSize}
              onChange={(selected) => handleFontSize(selected)}
            />
          </div>
        )}
        {data?.key === 'Status' && <StatusConfigComponent obj={obj} onChange={onChange} />}
        {(data?.key === 'Number_Percentage' || data?.key === 'Number_Decimal') && (
          <NumberPerConfigComponent
            obj={obj}
            onChange={onChange}
            colourSwitch={colourSwitch}
            forSwitch={forSwitch}
            chcekingFromDynamicArray={chcekingFromDynamicArray}
            controlKey={data?.key}
          />
        )}
        {data?.key === 'Calculation' && (
          <CalculationConfigComponent
            obj={obj}
            onChange={onChange}
            colourSwitch={colourSwitch}
            forSwitch={forSwitch}
            chcekingFromDynamicArray={chcekingFromDynamicArray}
            controlKey={data?.key}
          />
        )}
        {data?.key === 'Signature' && (
          <SignatureConfigComponent
            obj={obj}
            handleFont={handleFont}
            getImage={getImage}
            handleUploadImage={handleUploadImage}
            handleRemoveImage={handleRemoveImage}
          />
        )}

        {data?.key === 'Company_Stamp' && (
          <CompanyStampConfigComponent obj={obj} getImage={getImage} handleUploadImage={handleUploadImage} handleRemoveImage={handleRemoveImage} />
        )}
        {data?.key === 'Image' && (
          <ImageConfigComponent obj={obj} getImage={getImage} handleUploadImage={handleUploadImage} handleRemoveImage={handleRemoveImage} />
        )}
        {data?.key === 'Divider' && <DividerConfigComponent obj={obj} handleDividerSetting={handleDividerSetting} />}
        {data?.key === 'Label' && (
          <div className="p-2">
            <DndProvider backend={HTML5Backend}>
              {obj?.labelColours?.map((labelEle, labelIndex) => {
                return renderlabelList(labelEle, labelIndex);
              })}
            </DndProvider>
          </div>
        )}
        <div className="px-2 mt-1">
          {obj?.options?.map((ele, i) => {
            return (
              <div key={ele} className="d-flex mb-2">
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    className="form-control"
                    name={ele?.name || 'Text Box'}
                    placeholder={`${t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.TEXT_FOR_OPTION')} ${i + 1}`}
                    value={ele?.name || ele?.label}
                    onChange={(e) => onChange(e.target.value, `Label selection required ${i + 1}`, i)}
                    onBlur={(e) => trimLabel(e.target.value, `Label selection required ${i + 1}`, i)}
                  />
                  <label className="asterisk-req">{t('CUSTOM_MODULE.OPTION_LABEL')}</label>
                </div>
                {i + 1 === obj?.options?.length && (
                  <button type="button" className="btn btn-outline ml-auto mt-4" onClick={() => addOption(obj)}>
                    <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.ADD')}</span>
                    <span className="icon-add" />
                  </button>
                )}
                {obj?.options?.length !== 1 && (
                  <button type="button" className="btn btn-outline mt-4" onClick={() => removeOption(i)}>
                    <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.DELETE')}</span>
                    <span className="icon-delete" />
                  </button>
                )}
              </div>
            );
          })}
        </div>
        <div className="px-2 mt-1">
          {data?.key === 'Date_Picker' && (
            <div className="checkbox-label my-3" key="range_0">
              <input
                type="checkbox"
                id={`isRange_${dataIndex}`}
                key={`isRange_${dataIndex}`}
                name="Enable"
                checked={obj?.range}
                onChange={(e) => onChange(e.target.checked, 'range', 0)}
              />
              <label htmlFor={`isRange_${dataIndex}`} className="chklabel">
                <span>{t('CUSTOM_MODULE.IS_RANGE_TYPE')}</span>
              </label>
            </div>
          )}
          <div className="checkbox-label my-3" key="enable_0">
            <input
              type="checkbox"
              id="enable_0"
              key="enable_0"
              name="Enable"
              checked={obj?.supplierVisible}
              onChange={(e) => onChange(e.target.checked, 'Supplier Visible', 0)}
            />
            <label htmlFor="enable_0" className="chklabel">
              <span>{t('CUSTOM_MODULE.VISIBLE_SUPPLIER')}</span>
            </label>
          </div>
          {['Source', 'Calculation', 'Dependent'].includes(data?.key) ? null : (
            <div className="checkbox-label my-3" key="require_1">
              <input
                type="checkbox"
                id="require_1"
                key="require_1"
                name="Required"
                checked={obj?.supplierEditable}
                onChange={(e) => onChange(e.target.checked, 'Supplier Editable', 1)}
              />
              <label htmlFor="require_1" className="chklabel">
                <span>{t('CUSTOM_MODULE.EDITABLE_SUPPLIER')}</span>
              </label>
            </div>
          )}
        </div>
      </>
    );
  };
  const areAllColumnsEmpty = data?.key === 'Table' || data?.key === 'HTML' ? false : data?.columns?.every((column) => column.length === 0);

  const handleSaveConfig = () => {
    if (requiredLabelKeys.includes(obj?.key) && obj?.label?.trim() === '') {
      toasterMsg(t('CUSTOM_MODULE.LABEL_REQUIRED'), 'danger');
    } else {
      const results = obj?.options?.filter((eleOption) => eleOption?.name?.trim() === '');
      if (results?.length > 0) {
        toasterMsg(t('CUSTOM_MODULE.OPTION_REQUIRED'), 'danger');
      } else {
        submit(obj || data, dataIndex);
      }
    }
  };

  const filePreview = (element) => {
    return element ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element}`) : '';
  };

  const imageSrc = (imageData) => {
    return imageData?.includes('base64') ? getImage(imageData) : filePreview(imageData);
  };
  return (
    <>
      <div className="common-config-container">
        <Card className="common-custom-card">
          <Card.Header className="d-flex">
            <p className="mb-0 f-24 flex-fill text-center">{t('CUSTOM_MODULE.FIELD_PROPERTIES')}</p>
            <button name="close" onClick={toggle} className="btn ml-auto" type="button">
              <span className="icon-close cursor-pointer" />
            </button>
          </Card.Header>
          <Card.Body className="overflow-auto p-0 f-14">
            {data?.forLabel ? (
              <>
                <strong className="p-2 d-block">{t('CUSTOM_MODULE.SECTION_PROPERTIES')}</strong>
                <div className="mt-1 p-2 d-block">
                  <div className="input-group form-floating-label fixed-label">
                    <input
                      type="text"
                      className="form-control"
                      name={obj?.name || 'Text Box'}
                      placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.CONFIG_MODAL.LABEL_FOR_SECTION')}
                      value={obj?.label}
                      onChange={(e) => onChange(e.target.value, 'Label')}
                      onBlur={(e) => trimLabel(e.target.value, 'Label')}
                    />
                    <label className="asterisk-req">{t('CUSTOM_MODULE.LABEL')}</label>
                  </div>
                </div>
              </>
            ) : (
              mainBodyData()
            )}
          </Card.Body>
          <Card.Footer>
            <button
              disabled={areAllColumnsEmpty}
              aria-label={t('CUSTOM_MODULE.SAVE')}
              className="btn d-inline-flex p-0"
              type="button"
              onClick={() => handleSaveConfig()}
            >
              <span className="icon-Tick-1 f-24" />
            </button>
          </Card.Footer>
        </Card>
      </div>
      {imageModal.isOpen && (
        <Modal className="common-custom-modal modal-large" show={imageModal.isOpen} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('CUSTOM_MODULE.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleImageUpload('close')} className="icon-close cursor-pointer text-dark text-decoration-none" />
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body">
              <ImgDropzone
                ref={childRef}
                onSubmit={handleImageUpload}
                acceptedFileExtenstion=".jpeg,.png,.jpg"
                title={imageModal.controlKey}
                image={(() => {
                  if (obj?.key === 'Company_Stamp') {
                    return getImage(obj?.companyLogo);
                  }

                  if (obj?.key === 'Image') {
                    return imageSrc(obj?.imageUrl);
                  }

                  return getImage(obj?.digitalSignPath);
                })()}
                isEditMode={false}
                cropSize="FREE"
                fromCustomModule
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default ConfigModal;
